import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './ProductLogo.css';

interface ProductLogoProps {
  title: string;
  subtitle?: React.ReactNode;
  homeURL?: string;
  hideLogo?: boolean;
}

const ProductLogo = ({
  title,
  subtitle,
  homeURL,
  hideLogo = false
}: ProductLogoProps): React.ReactElement => {
  const formattedTitle = title.startsWith('Axe ') ? (
    <>
      Axe <span>{title.substring(4)}</span>
    </>
  ) : (
    <span>{title}</span>
  );

  const content = (
    <div className={styles.content}>
      <h3 className={styles.title}>{formattedTitle}</h3>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
    </div>
  );

  // TODO: once multiple integrations are supported, this will need to be updated to handle it
  const integrationStyles = title.match(/jira .*integration/i)
    ? styles.integration
    : undefined;

  const hideLogoStyles = hideLogo ? styles.hideLogo : undefined;

  return (
    <div className={classNames(styles.wrap, integrationStyles, hideLogoStyles)}>
      {homeURL ? <Link to={homeURL}>{content}</Link> : content}
    </div>
  );
};

export default ProductLogo;
